import { render, staticRenderFns } from "./LenderReviewRating.vue?vue&type=template&id=780282f6&"
import script from "./LenderReviewRating.vue?vue&type=script&lang=js&"
export * from "./LenderReviewRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports